<template>
  <div>
    <v-dialog v-model="dialog" v-if="dialog" max-width="40vw" persistent>
      <EditCommissionTarget
        :details="selected"
        :head="headAgent"
        :isUpdating="isUpdating"
        @close="close"
      ></EditCommissionTarget>
    </v-dialog>
    <v-card>
      <v-card-title>
        <v-title>Manage Commissions Targets</v-title>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap class="px-0 pb-3">
          <v-flex style="text-align: right;">
            <v-btn color="primary" dark class="mb-2" @click="onAddUser">
              Add User
            </v-btn>
          </v-flex>
        </v-layout>
        <div wrap class="px-5 pt-3 mb-3" style="background: #efefef;">
          <v-layout wrap class="px-0">
            <v-flex xs12 sm4 md1>
              <p class="font-weight-bold">Filter by:</p>
            </v-flex>
            <v-flex xs12 sm4 md2 class="px-3">
              <v-select
                v-model="year"
                :items="dateRange"
                @change="setFilteredCommissions(retrieveCommissions)"
                label="Year"
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4 md2 class="px-3">
              <v-select
                v-model="month"
                :items="staticMonth"
                :item-text="staticMonth.text"
                :item-value="staticMonth.value"
                @change="setFilteredCommissions(retrieveCommissions)"
                label="Month"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4 md6 class="px-3">
              <v-autocomplete
                v-model="userTarget.salesRep"
                :items="filterDealers"
                item-text="dealerFullName"
                item-value="dealerFullName"
                chips
                small-chips
                label="Sales Representative"
                multiple
                solo
                @change="setFilteredCommissions(retrieveCommissions)"
              ></v-autocomplete>
            </v-flex>  
            <v-flex xs12 sm4 md1 class="px-3">
              <v-btn variant="flat" @click="clearFilter" :disabled="isDisabled">
                Clear Filter
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <ag-grid-vue
          domLayout="autoHeight"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="rowData"
          :defaultColDef="defaultColDef"
          :frameworkComponents="frameworkComponents"
          :rowSelection="'multiple'"
          @first-data-rendered="onFirstDataRendered"
          @grid-ready="onGridReady"
          @selection-changed="onSelectionChanged"
          :paginationPageSize="10"
        ></ag-grid-vue>

        <div class="text-center">
          <v-pagination
            v-model="paging.pageNo"
            total-visible="7"
            :length="totalPages"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="paginationChange"
          ></v-pagination>
        </div>
        <v-layout row wrap class="px-0 pt-3">
          <v-flex xs12 style="text-align: right;">
            <v-btn
              color="primary"
              class="mb-2"
              @click="bulkRemove"
              :disabled="selectedRows.length == 0"
            >
              Remove User/s
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <ValidationObserver
        ref="observer"
        v-slot="{ invalid }"
      ></ValidationObserver>
    </v-card>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import { createNamespacedHelpers } from 'vuex';
import EditCommissionTarget from '../components/admin/commissionTargets/EditCommissionTarget.vue';
import TableActions from '../components/admin/commissionTargets/TableActions.vue';
import { isArray } from 'util';

const { mapActions: mapCommissionTargetsActions } = createNamespacedHelpers(
  `orders/commissionTargets`
);

const { mapActions: mapDealerActions } = createNamespacedHelpers(
  `orders/dealer`
);

export default {
  name: 'manageCommissionTarget',
  components: {
    AgGridVue,
    EditCommissionTarget,
    TableActions,
  },
  data: () => ({
    gridOptions: null,
    columnDefs: null,
    defaultColDef: null,
    rowData: null,
    gridApi: null,
    columnApi: null,
    frameworkComponents: null,
    dialog: false,
    selected: {},
    selectedRows: [],
    headAgent: null,
    isUpdating: false,
    SearchText: null,
    year: 0,
    month: 0,
    staticMonth: [],
    userTarget: {},
    allDealers: [],
    filteredCommissions: {},
    totalPages: 0,
    paging: {
      pageNo: 1,
      pageSize: 10,
      keyword: '',
    },
  }),
  computed: {
    dateRange: () => {
      const date = new Date().getFullYear();

      let result = [...Array(date + 6 - (date - 5)).keys()].map(
        i => i + (date - 5)
      );
      return result;
    },
    filterDealers() {
      let vm = this;
      return vm.allDealers;
    },
    isDisabled() {
      let vm = this;
      return vm.month == 0 && vm.year == 0 && vm.userTarget.salesRep == null ? true : false
    },
    retrieveCommissions: { 
      get() {
        let vm = this;
        let commission = {
          year: vm.year,
          month: vm.month,
          salesRep: vm.userTarget.salesRep,
          pagination: {
            pageNo: vm.paging.pageNo,
            pageSize: vm.paging.pageSize,
          },
        };
        return commission;
      }, 
      set(newValue) { 
        return newValue;
      },
    },
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};

    vm.columnDefs = [
      {
        headerName: 'Sales Representative',
        field: 'salesRep',
        sortable: true,
        checkboxSelection: true,
        showDisabledCheckboxes: true,
      },
      {
        headerName: 'Sales Stream',
        field: 'salesStream',
        sortable: true,
        width: 100,
      },
      {
        headerName: 'Target Type',
        field: 'targetType',
        sortable: true,
        width: 100,
      },
      {
        headerName: 'Target',
        field: 'target',
        sortable: true,
        width: 150,
      },
      {
        headerName: 'Date',
        field: 'date',
        sortable: true,
        valueFormatter: param => {
          return vm.$options.filters.formatDate(param.value);
        },
      },
      {
        headerName: 'Actions',
        cellRenderer: 'tableActions',
        suppressSizeToFit: true,
        cellRendererParams: {
          onEdit: function(param) {
            vm.onEditCommTarget(param);
          },
          onDelete: function(param) {
            vm.onDeleteCommTarget(param);
          },
        },
      },
    ];

    vm.frameworkComponents = {
      tableActions: TableActions,
    };
    vm.defaultColDef = {
      autoHeight: true,
    };
  },
  mounted() {
    let vm = this;
    vm.getFilteredCommissions(vm.retrieveCommissions);
    vm.staticMonth = [
      { text: 'January', value: 1 },
      { text: 'February', value: 2 },
      { text: 'March', value: 3 },
      { text: 'April', value: 4 },
      { text: 'May', value: 5 },
      { text: 'June', value: 6 },
      { text: 'July', value: 7 },
      { text: 'August', value: 8 },
      { text: 'September', value: 9 },
      { text: 'October', value: 10 },
      { text: 'November', value: 11 },
      { text: 'December', value: 12 },
    ];
    vm.listDealersManagement().then(data => {
      vm.allDealers = data.filter(x => x.dealerStatus != 'Customer');
    });
  },
  methods: {
    ...mapCommissionTargetsActions([
      'getCommissionTargets',
      'deleteCommissionTargets',
      'filterCommissionTarget',
    ]),
    ...mapDealerActions(['listDealersManagement']),
    setFilteredCommissions(val) {
      const vm = this;
 
      val.salesRep =
        Array.isArray(val.salesRep) && val.salesRep.length == 0  
          ? null
          : val.salesRep;

      val.pagination.pageNo = 1;
 
      vm.getFilteredCommissions(val);
    },
    getFilteredCommissions(val) {
      const vm = this;

      vm.filterCommissionTarget(val).then(data => {
        vm.rowData = data.items;
        vm.totalPages = data.totalPages;
      });
    },
    clearFilter() {
      const vm = this;
      let query = (vm.retrieveCommissions = {
        month: (vm.month = 0),
        year: (vm.year = 0),
        salesRep: (vm.userTarget.salesRep = null),
        pagination: {
          pageNo: 1,
          pageSize: vm.paging.pageSize,
        },
      });
      vm.getFilteredCommissions(query); 
    },
    paginationChange(val) {
      const vm = this;
      let query = vm.retrieveCommissions;
      query.pagination.pageNo = val;

      vm.getFilteredCommissions(query);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },
    onFirstDataRendered(grid) {
      grid.api.sizeColumnsToFit();
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
    },
    onAddUser() {
      this.selected = {
        date: new Date().toISOString().substr(0, 10),
        salesRep: null,
        salesStream: null,
        targetType: null,
        target: '',
        id: null,
      };
      // this.headAgent = data.headDealer
      this.isUpdating = false;
      this.dialog = true;
    },
    onEditCommTarget(data) {
      data.date = new Date(data.date.split('T')[0]).toISOString().substr(0, 10);
      this.selected = data;
      this.isUpdating = true;
      this.dialog = true;
    },
    onDeleteCommTarget(data) {
      let vm = this;
      let tempList = [];
      tempList.push(data);

      vm.deleteSelectedUser(tempList);
    },
    bulkRemove() {
      let vm = this;
      vm.deleteSelectedUser(vm.selectedRows);
    },
    deleteSelectedUser(data) {
      let vm = this;
      vm.$dialog
        .confirm('Are you sure you want to delete the row/s?')
        .then(() => {
          vm.deleteCommissionTargets(data)
            .then(data => {
              vm.close();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    close() {
      let vm = this;
      vm.selected = {
        date: new Date().toISOString().substr(0, 10),
        salesRep: null,
        salesStream: null,
        targetType: null,
        target: '',
        id: null,
      };
      vm.isUpdating = false;
      vm.dialog = false;
      vm.getCommTargets();
    },
  },
  filters: {
    formatDate: function(date) {
      if (!date) return null;

      const [year, month, day] = date.substring(0, 10).split('-');
      return `${year}-${month}`;
    },
  },
};
</script>

<style lang="scss" scoped></style>
